// Components
import { useState, useMemo, useRef, useEffect } from "react"
import { Button, Icon, MenuItem, Modal, Select } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"
import MDSelect from "components/MDSelect"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"

// Components - Calendar
import WeeklyPrevIcon from "components/icons/WeeklyPrevIcon"
import WeeklyNextIcon from "components/icons/WeeklyNextIcon"
import timezones from "layouts/calendar/data/timezone"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"

import { useUploadFileMutation } from "shared/redux/endpoints/employee"

// Components - Modal
import ModalWorkShop from "components/ModalWorkShop/ModalWorkShop"
import ModalLeaveApplication from "components/ModalLeaveApplication/ModalLeaveApplication"
import ModalLeaveAlert from "components/ModalLeaveAlert/ModalLeaveAlert"
import ModalLeaveSubmitStatus from "components/ModalLeaveSubmitStatus/ModalLeaveSubmitStatus"
import ModalLeaveRelatedInfomation from "components/ModalLeaveRelatedInfomation/ModalLeaveRelatedInfomation"
import ModalMyCalendarStudentAtRisk from "components/ModalMyCalendarStudentAtRisk/ModalMyCalendarStudentAtRisk"
import ModalActionEvent from "components/ModalActionEvent/ModalActionEvent"

// Context
import { useMaterialUIController } from "context"

// Utils
import { useLocation, useNavigate } from "react-router-dom"
import { ToastUtil } from "utilities/toastUtil"
import moment from "moment"
import { enUS } from "date-fns/locale"
import { debounce } from "lodash"
import axios from "axios"
import { globalConfigs } from "configs"

// Redux
import { useSelector } from "react-redux"
import { selectAuth } from "shared/redux/slices/authSlice"
import { useCreateLeaveRequestMutation } from "shared/redux/endpoints/leaveRequest"
import { useGetHubMutation } from "shared/redux/endpoints/sso"
import { useLazyGetClassSessionQuery } from "shared/redux/endpoints/calendar"
import {
  useLazyGetTeachersQuery,
  useLazyGetCentersQuery,
  useLazyGetCalendarLXOQuery,
  useCreateEventCalendarMutation,
  useLazyGetLeaveCalenDarQuery,
} from "shared/redux/endpoints/lxo"

// Sample data
import fakeCalendarData from "./fake-calendar-data"

// Constants
import { TypeClassSession } from "constant/TypeClassSession"

// Styles
import makeStyles from "pages/style"
import {
  titleTypography,
  descriptionTypography,
  noteTypography,
} from "shared/styles/style"
import {
  calendarContainer,
  calendarDayBottomHeader,
  calendarDayHeader,
  calendarDayTopHeader,
  calendarHeader,
  calendarSlotLabel,
  calendarTabMenu,
  calendarTabMenuItem,
  calendarTabMenuItemTitle,
  calendarTitle,
  customStyle,
  style,
  modalHeaderStyle,
  modalIconContainerStyle,
  modalButtonContainerStyle,
  modalButtonStyle,
  viewOptionsContainerStyle,
  viewOptionStyle,
  eventModalContentStyle,
  dayCellStyle,
} from "./style"
import modalCalendarIcon from "assets/images/apollo-english/calendar-modal.png"

import {
  pickUploadFiles,
  mapUploadedToDtoAttachments,
  mapExistingUrlToDtoAttachments,
} from "shared/utils/common"

// Utils
import {
  shouldFilterOutEvent,
  handleGroupedEvents,
  renderModalContentByType,
  getModalButtons,
  getNavigationParams,
} from "utilities/weeklyCalendarUtil"

import { RoleLabel } from "constant/Role"
import { Role } from "constant/Role"
import { useTreasureHunt } from "components/useTreasureHunt/useTreasureHunt"

const tabs = [
  { label: "All", value: "all" },
  {
    label: "Lesson",
    value: "lesson",
  },
  {
    label: "Demo/PT",
    value: "pt",
  },
  {
    label: "Tasks",
    value: "task",
  },

  {
    label: "EOCC & Test",
    value: "test",
  },
  {
    label: "Training/Workshop",
    value: "training",
  },
  { label: "Events", value: "events" },
]

const tabsLXO1 = [
  { label: "All", value: "all" },
  {
    label: "Lesson",
    value: "LESSON",
  },
  {
    label: "Demo/PT",
    value: "PT/DEMO",
  },
  {
    label: "Tasks",
    value: "TASK",
  },
  {
    label: "Event",
    value: "Event",
  },
  {
    label: "EOCC & Test",
    value: "EOCC/TEST",
  },
  {
    label: "Training/Workshop",
    value: "TRAINING/WORKSHOP",
  },
]

const viewOptions = [
  { label: "Week", value: "timeGridWeek" },
  { label: "Month", value: "dayGridMonth" },
]

function WeeklyCalendarLXO(props) {
  const { triggerIfNew: triggerCreateEventIfNew } = useTreasureHunt("lxo-create-event")
  const location = useLocation()
  const navigate = useNavigate()
  const {
    outerDate,
    dataWorkShop,
    onChangeTab,
    leaveData: leaveDataProp,
    ...args
  } = props
  const auth = useSelector(selectAuth)
  const userId = auth?.user?.userId

  const { start, end, setStart, setEnd } = props

  const isCenterCalendar = window.location.pathname.includes("center-calendar")

  const tabsLXO = isCenterCalendar
    ? [
        {
          label: "Event",
          value: "Event",
        },
      ]
    : tabsLXO1

  const classes = makeStyles()
  const [getHub] = useGetHubMutation()
  const [title, setTitle] = useState("")
  const [data, setData] = useState({})
  const [isOpen, setOpen] = useState(false)
  const [uploadFile] = useUploadFileMutation()

  const [triggerCalendarLeave, { data: leaveData }] =
    useLazyGetLeaveCalenDarQuery()

  const [teacherParams, setTeacherParams] = useState({
    page: 0,
    size: 5,
  })
  const [paginationTeacher, setPaginationTeacher] = useState({
    totalPage: 0,
    pageSize: 0,
    currentPage: 0,
    totalElement: 0,
  })
  const [teachers, setTeachers] = useState([])
  const [selectedTeacher, setSelectedTeacher] = useState(null)

  const centerId = auth?.centerId
  const role = auth?.role

  const [payloadSubmit, setPayloadSubmit] = useState({})
  const [isSubmitSuccess, setIsSubmitSuccess] = useState(false)
  const [isOpenModalLeave, setIsOpenModalLeave] = useState(false)
  const [isOpenModalLeaveAlert, setIsOpenModalLeaveAlert] = useState(false)
  const [isOpenModalLeaveAlertHoliday, setIsOpenModalLeaveAlertHoliday] =
    useState(false)
  const [isOpenModalLeaveSubmitStatus, setIsOpenModalLeaveSubmitStatus] =
    useState(false)
  const [dataRelatedInformation, setDataRelatedInformation] = useState([])
  const [errorMessage, setErrorMessage] = useState("")
  const [
    isOpenModalLeaveRelatedInformation,
    setIsOpenModalLeaveRelatedInformation,
  ] = useState(false)
  const [isOpenModalActionEvent, setIsOpenModalActionEvent] = useState(false)

  const [dataModalLeave, setDataModalLeave] = useState({})
  const [dataEvent, setDataEvent] = useState({})

  const [createLeaveRequest] = useCreateLeaveRequestMutation()
  const calendarRef = useRef(null)
  const lastWeekDateRef = useRef(null)
  const currentMonthRef = useRef(null)
  const monthAnchorDateRef = useRef(null)
  const [constroller] = useMaterialUIController()
  const { miniSidenav } = constroller

  const tabsRender = role === RoleLabel[Role.LXO] ? tabsLXO : tabs

  // Weekly Calendar State
  const [tab, setTab] = useState(tabsRender[0])
  const [events, setEvents] = useState([])
  const [eventsByDay, setEventsByDay] = useState({})
  const [timezone, setTimeZone] = useState(
    (new Date().getTimezoneOffset() / 60) * -1
  )

  const [triggerCalendar, { data: dataCalendar, isFetching: isLoading }] =
    useLazyGetCalendarLXOQuery()

  /* get teachers by api */
  const [triggerTeachers, isLoadingTeachers] = useLazyGetTeachersQuery()
  const [createEventCalendar] = useCreateEventCalendarMutation()

  /* get centers by api */
  const [triggerCenters, isLoadingCenters] = useLazyGetCentersQuery()

  const fetchTeachers = async (params) => {
    const response = await triggerTeachers(params)
    // console.log({ isLoadingTeachers });
    if (response?.isSuccess && response?.data?.status) {
      const teachers = response?.data?.data?.data.map((item) => ({
        ...item,
        label: item.fullName,
        value: item.username,
      }))
      setTeachers((prev) => {
        return [...prev, ...teachers]
      })
      setPaginationTeacher({
        totalPage: response?.data?.data?.totalPage,
        pageSize: response?.data?.data?.pageSize,
        currentPage: response?.data?.data?.currentPage,
        totalElement: response?.data?.data?.totalElement,
      })
    }
  }

  const onInputChangeSearchTeacher = debounce(async (newValue) => {
    if (!newValue) {
      return
    }
    const newParams = {
      ...teacherParams,
      page: 0,
      search: newValue,
    }
    fetchTeachers(newParams)
    setTeacherParams(newParams)
  }, 1000)
  const handleScrollBottomTeacher = () => {
    /* totalpage == currentpage */
    const { totalPage, currentPage } = paginationTeacher
    if (totalPage === currentPage) {
      return
    }
    const newParams = {
      ...teacherParams,
      page: paginationTeacher.currentPage + 1,
    }
    fetchTeachers(newParams)
    setTeacherParams(newParams)
  }
  useEffect(() => {
    fetchTeachers()
  }, [])

  const params = new URLSearchParams(location.search)
  const [view, setView] = useState("timeGridWeek")
  const [isActiveDayOff, setIsActiveDayOff] = useState(false)
  const [date, setDate] = useState(null)

  const handleChangeDate = (start, end) => {
    setStart(start)
    setEnd(end)
  }

  useEffect(() => {
    if (start && end) {
      const fetchData = async () => {
        try {
          await triggerCalendar({
            page: "",
            size: 100,
            sort: "",
            startDate: start,
            endDate: end,
            eventType: tab.value,
            centerId,
          })
          triggerCalendarLeave({
            centerId,
            startDate: start,
            endDate: end,
          })
        } catch (error) {
          console.error("Error fetching data:", error)
        }
      }

      fetchData()
    }
  }, [start, end, tab, centerId])

  useEffect(() => {
    triggerCalendar({
      startDate: start,
      endDate: end,
      eventType: tab.value,
      centerId,
    })
  }, [])

  useEffect(() => {
    if (dataCalendar?.status) {
      const data = {
        ...dataCalendar?.data,
      }

      let newEvents = []

      Object.entries(data ?? {}).forEach(([key, value]) => {
        value.forEach((item) => {
          newEvents = handleGroupedEvents(newEvents, key, item, timezone)
        })
      })

      newEvents = newEvents
        .filter((event) => !shouldFilterOutEvent(tab.value, event))
        .filter((event, _, self) => {
          if (event.type === "Lesson") {
            return !self.some(
              (e) =>
                e.start === event.start &&
                e.end === event.end &&
                e.type === "EOCC & Test"
            )
          }
          return true
        })

      const newEventsByDay = newEvents.reduce((acc, current) => {
        const date = current?.start?.split(" ")[0]
        if (!acc[date]) acc[date] = []
        acc[date].push(current)
        return acc
      }, {})

      setEvents(newEvents)
      setEventsByDay(newEventsByDay)
    } else {
      setEvents([])
      setEventsByDay({})
    }
  }, [dataCalendar, tab, timezone])

  const onChangeViewOption = (value) => {
    if (value === view) return
    const api = calendarRef.current?.getApi()
    const currentDate = api?.getDate()

    let changeDate = null
    if (value === "timeGridWeek") {
      if (
        lastWeekDateRef.current &&
        currentMonthRef.current &&
        moment(lastWeekDateRef.current).format("YYYY-MM") ===
          currentMonthRef.current
      ) {
        changeDate = lastWeekDateRef.current
      } else {
        changeDate =
          monthAnchorDateRef.current ||
          (currentDate ? moment.utc(currentDate).format("YYYY-MM-DD") : null)
      }
    } else if (currentDate) {
      changeDate = currentDate
    }
    setView(value)
    setIsActiveDayOff(value === "dayGridMonth")
    if (changeDate) {
      api?.changeView(value, changeDate)
      if (typeof changeDate === "string") {
        setDate(changeDate)
      } else {
        setDate(moment.utc(changeDate).format("YYYY-MM-DD"))
      }
    } else {
      api?.changeView(value)
    }
    api?.render()
  }

  const onClickForDayGridMonth = (isActiveDayOff) => {
    if (isActiveDayOff) {
      if (isActiveDayOff) {
        setDataModalLeave(isActiveDayOff)
        setIsOpenModalLeave(true)
      }
    }
  }

  useEffect(() => {
    const api = calendarRef?.current?.getApi?.()
    api?.gotoDate?.(outerDate)

    const currentView = api?.view
    if (!currentView) return

    const start = currentView.currentStart || currentView.activeStart
    const end = currentView.currentEnd || currentView.activeEnd
    handleChangeDate(
      moment(start).format("YYYY-MM-DD"),
      moment(end).format("YYYY-MM-DD")
    )
  }, [outerDate])

  useEffect(() => {
    setTimeout(() => {
      calendarRef.current?.getApi().render()
    }, 500)
  }, [miniSidenav])

  useEffect(() => {
    setDate(outerDate)
  }, [outerDate])

  const _title = useMemo(() => {
    if (view === "dayGridMonth") {
      return date
        ? moment(date).format("MMMM YYYY")
        : moment(
            calendarRef.current?.getApi()?.currentData?.currentDate
          ).format("MMMM YYYY")
    }

    const startDate = date
      ? moment(date).startOf("isoWeek")
      : moment(calendarRef.current?.getApi()?.view.currentStart)
    const endDate = date
      ? moment(date).endOf("isoWeek")
      : moment(calendarRef.current?.getApi()?.view.currentEnd)

    return `${startDate.format("Do")} ${
      startDate.format("MMMM") !== endDate.format("MMMM")
        ? startDate.format("MMMM")
        : ""
    } - ${endDate.format("Do")} ${endDate.format("MMMM")}`
  }, [calendarRef.current, view, title, date])

  const handleDateClick = (info) => {
    console.log("Clicked on date:", info.dateStr)
  }

  useEffect(() => {
    onChangeTab && onChangeTab(tab)
  }, [tab, timezone])

  const openNewLms = async (options) => {
    const { userId, type = "LESSON_DETAIL", hubClassSessionId } = options

    try {
      const res = await axios.post(
        globalConfigs.urlSSOLms + "/auth/redirect-my-apollo/generate",
        {
          hubUserId: userId,
          type: type === "TEACHER" ? "TEACHER_SCHEDULE" : type,
          ...(type === "LESSON_DETAIL" && { hubClassSessionId }),
        },
        {
          headers: {
            "x-api-key": globalConfigs.apiKeySSO,
          },
        }
      )

      const redirectLink = res && res.data && res.data.redirectLink
      if (redirectLink) {
        window.open(redirectLink, "_blank")
      } else {
        ToastUtil.showToastError("Can't open LMS. Please try again")
      }
    } catch (err) {
      ToastUtil.showToastError("Can't open LMS. Please try again")
    }
  }

  const handleLmsClick = async () => {
    const id = data?.extendedProps?.data?.id
    if (!id) return
    await openNewLms({
      hubClassSessionId: id,
      userId,
      type: "LESSON_DETAIL",
    })
  }

  const handleHubClick = async () => {
    const res = await getHub({
      redirectURL: `http://hub24.apollo.vn:7777/event/ptonline`,
    })
    const _data = res?.data?.data
    if (_data) {
      window.open(_data, "_blank")
    }
  }

  const handleNavigate = (type, data) => {
    const params = getNavigationParams(type, data)
    navigate(
      `/assistant/my-tasks?id=${params.id}&start=${params.start}&end=${params.end}&type=${params.type}`
    )
    console.log("11zz", params)
  }

  const renderDefaultModal = () => (
    <Modal
      open={isOpen}
      onClose={() => {
        setOpen(false)
        setData({})
      }}
    >
      <MDBox sx={{ ...style }}>
        <MDBox sx={modalHeaderStyle}>
          <MDBox sx={modalIconContainerStyle}>
            <MDBox
              sx={{ width: 29 }}
              component="img"
              src={modalCalendarIcon}
            ></MDBox>
          </MDBox>
          <MDBox>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...titleTypography(breakpoints),
                lineHeight: 1.37,
              })}
            >
              Details
            </MDTypography>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                lineHeight: 1.5,
              })}
            >
              Type : {data?.extendedProps?.type}
            </MDTypography>
          </MDBox>
        </MDBox>

        <MDBox sx={eventModalContentStyle}>
          {renderModalContentByType(data).map((item, index) => (
            <MDTypography
              key={index}
              sx={({ breakpoints }) => ({
                ...descriptionTypography(breakpoints),
                lineHeight: 1.5,
              })}
            >
              {item.label}: {item.value}
            </MDTypography>
          ))}
        </MDBox>

        <MDBox sx={modalButtonContainerStyle} role={undefined} tabIndex={-1}>
          {getModalButtons(data?.extendedProps?.type, data, {
            onClose: () => setOpen(false),
            onLmsClick: handleLmsClick,
            onHubClick: handleHubClick,
            onNavigate: handleNavigate,
          }).map((button, index) => (
            <Button
              key={index}
              variant="contained"
              sx={modalButtonStyle}
              onClick={button.onClick}
            >
              {button.text}
            </Button>
          ))}
        </MDBox>
      </MDBox>
    </Modal>
  )

  const dynamicByType = (type) => {
    switch (type) {
      case "Training/Workshop":
        return (
          <ModalWorkShop
            isOpen={isOpen}
            onClose={() => {
              setOpen(false)
              setData({})
            }}
            data={data}
          />
        )
      case TypeClassSession.STUDENTS_AT_RISK:
        return (
          <ModalMyCalendarStudentAtRisk
            isOpen={isOpen}
            setOpen={setOpen}
            icon={modalCalendarIcon}
            onClose={() => {
              setOpen(false)
              setData({})
            }}
            dataExtendedProps={data?.extendedProps}
          />
        )
      default:
        return renderDefaultModal()
    }
  }

  // Modal props
  const propsModalLeaveApplication = {
    isOpen: isOpenModalLeave,
    onClose: () => setIsOpenModalLeave(false),
    onSubmit: (data) => {
      setPayloadSubmit(data)
      setIsOpenModalLeave(false)
      setIsOpenModalLeaveRelatedInformation(true)
    },
    date: dataModalLeave,
  }

  async function submitLeave(form) {
    const selectedFiles = Array.isArray(form?.attachments)
      ? form.attachments
      : []

    // 1) Upload nếu có File mới
    const filesToUpload = pickUploadFiles(selectedFiles)

    let uploaded = []
    if (filesToUpload.length > 0) {
      const formData = new FormData()
      filesToUpload.forEach((file) => {
        formData.append("attachments", file)
      })

      uploaded = await uploadFile(formData)

      // uploaded items đúng format backend bạn đưa
    }

    // 2) Map attachments vào dto
    const attachments = [
      ...mapExistingUrlToDtoAttachments(selectedFiles),
      ...mapUploadedToDtoAttachments(uploaded),
    ]

    // 3) Dedup theo url (tránh trùng nếu UI lỡ giữ cả url + File)
    const seen = new Set()
    const dedupedAttachments = attachments.filter((a) => {
      const key = a.url
      if (!key) return false
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })

    // 4) Build dto submit
    const dto = {
      // ...form,
      leaveType: form?.leaveType?.value,
      startDate: moment(form.fromDate).format("YYYY-MM-DD"),
      endDate: moment(form.toDate).format("YYYY-MM-DD"),
      dayType: form.isHalfDay ? "HALF_DAY" : "FULL_DAY",
      reason: form.reason ?? "Medical leave",
      approverId: form.approver?.userId || form?.approver?.id,
      notificationRecipientIds: form.notifyTo?.map((u) => u.id),
      uploadedAttachments: dedupedAttachments,
    }

    return createLeaveRequest(dto).then((result) => {
      if (result?.error) {
        setIsSubmitSuccess(false)
        setErrorMessage(
          result?.error?.data?.data?.message || "Submit leave request failed"
        )
      } else {
        setIsSubmitSuccess(true)
      }
    })
  }

  const propsModalLeaveRelatedInformation = {
    isOpen: isOpenModalLeaveRelatedInformation,
    onClose: () => setIsOpenModalLeaveRelatedInformation(false),
    onSubmit: async () => {
      try {
        submitLeave(payloadSubmit)
      } catch (e) {
        setIsSubmitSuccess(false)
      }
      setIsOpenModalLeaveRelatedInformation(false)
      setIsOpenModalLeaveSubmitStatus(true)
    },
    dataRelatedInformation: dataRelatedInformation,
  }

  const propsModalLeaveAlert = {
    isOpen: isOpenModalLeaveAlert,
    onClose: () => setIsOpenModalLeaveAlert(false),
    onSubmit: () => {
      setIsOpenModalLeaveAlert(false)
      setIsOpenModalLeave(true)
    },
  }

  const propsModalLeaveAlertHoliday = {
    isOpen: isOpenModalLeaveAlertHoliday,
    onClose: () => setIsOpenModalLeaveAlertHoliday(false),
    onSubmit: () => {},
    isAlertHoliday: true,
  }

  const propsModalLeaveSubmitStatus = {
    isOpen: isOpenModalLeaveSubmitStatus,
    onClose: () => setIsOpenModalLeaveSubmitStatus(false),
    onSubmit: () => {
      setIsOpenModalLeaveSubmitStatus(false)
    },
    status: isSubmitSuccess,
    errorMessage,
  }

  const propsModalActionEvent = {
    isOpen: isOpenModalActionEvent,
    onClose: () => setIsOpenModalActionEvent(false),
    onSubmit: (data) => {
      setIsOpenModalActionEvent(false)
      const dataSubmit = {
        category: data.category.value,
        name: data.name,
        startTime: moment(data.startDate).format("YYYY-MM-DD HH:mm:ss.SSS"),
        endTime: moment(data.endDate).format("YYYY-MM-DD HH:mm:ss.SSS"),
        description: data?.decription,
        location: data?.location,
        centerIds: [data?.center?.value],
      }

      createEventCalendar(dataSubmit).then((res) => {
        if (res?.data?.status) {
          ToastUtil.showToastSuccess("Create event successfully")
        } else {
          ToastUtil.showToastError("Create event failed")
        }
      })
    },
    data: dataEvent,
    triggerCenters,
    isLoadingCenters,
  }

  return (
    <MDBox
      sx={calendarContainer}
      id="weekly"
      className={`calendar-weekly ${view}`}
    >
      <MDBox sx={calendarHeader}>
        <MDBox
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            height: 28,
          }}
        >
          <MDBox
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              "& > div": {
                height: 28,
                cursor: "pointer",
              },
            }}
          >
            <MDBox
              onClick={() => {
                const api = calendarRef.current?.getApi()
                api?.prev()
                setTitle(api?.view?.title || "")
                const start = api?.view?.currentStart || api?.view?.activeStart
                const end = api?.view?.currentEnd || api?.view?.activeEnd
                setDate(null)
                if (start && end) {
                  handleChangeDate(
                    moment(start).format("YYYY-MM-DD"),
                    moment(end).format("YYYY-MM-DD")
                  )
                }
              }}
              sx={{
                "& svg": {
                  width: "24px",
                  height: "24px",
                },
              }}
            >
              <Icon component={WeeklyPrevIcon} />
            </MDBox>
            <MDBox
              onClick={() => {
                const api = calendarRef.current?.getApi()
                api?.next()
                setTitle(api?.view?.title || "")
                const start = api?.view?.currentStart || api?.view?.activeStart
                const end = api?.view?.currentEnd || api?.view?.activeEnd
                setDate(null)
                if (start && end) {
                  handleChangeDate(
                    moment(start).format("YYYY-MM-DD"),
                    moment(end).format("YYYY-MM-DD")
                  )
                }
              }}
              sx={{
                "& svg": {
                  width: "24px",
                  height: "24px",
                },
              }}
            >
              <Icon component={WeeklyNextIcon} />
            </MDBox>
          </MDBox>

          <MDTypography variant="span" sx={calendarTitle}>
            {_title}
          </MDTypography>
        </MDBox>
        <MDBox
          sx={calendarTabMenu}
          className={classes.containerCalendarFilterTabs}
        >
          {tabsRender.map((_tab, index) => (
            <MDBox
              key={index}
              sx={(theme) =>
                calendarTabMenuItem(theme, {
                  active: _tab.value === tab.value,
                })
              }
              onClick={() => setTab(_tab)}
            >
              <MDTypography sx={calendarTabMenuItemTitle}>
                {_tab.label}
              </MDTypography>
            </MDBox>
          ))}
          <InfoIcon
            type={TooltipType.TYPE_2}
            teacherInfoIconBlock={teacherInfoIconBlock.FILTER_TABS}
            color={TooltipIconColor.BLUE}
            className={classes.containerInfoIconWith4}
            sx={{ right: "15px" }}
          />
        </MDBox>
      </MDBox>
      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          my: "16px",
        }}
      >
        <MDBox sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <MDBox sx={{ position: "relative" }}>
            <MDBox sx={viewOptionsContainerStyle}>
              {viewOptions.map((viewOption) => (
                <MDBox
                  key={viewOption.value}
                  sx={viewOptionStyle(view === viewOption.value)}
                  onClick={(e) => {
                    e.preventDefault()
                    onChangeViewOption(viewOption.value)
                  }}
                >
                  <MDTypography
                    sx={({ breakpoints }) => ({
                      ...noteTypography(breakpoints),
                      color: "#FFFFFF",
                      fontSize: "14px !important",
                    })}
                  >
                    {viewOption.label}
                  </MDTypography>
                </MDBox>
              ))}
            </MDBox>
            <InfoIcon
              type={TooltipType.TYPE_2}
              teacherInfoIconBlock={teacherInfoIconBlock.WEEK_MONTH}
              color={TooltipIconColor.BLUE}
              sx={{
                right: "-12px",
                position: "absolute",
                top: "-15px",
                margin: 0,
              }}
            />
          </MDBox>
        </MDBox>

        <MDBox className={classes.groupButtonRight}>
          <MDBox
            className={classes.containerCalendarBreakdownUnderSmallCalendar}
          >
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={timezone}
              onChange={(e) => setTimeZone(e.target.value)}
              sx={{
                ...customStyle,
                width: "100px",
                "& input.MuiSelect-select": {
                  padding: "10px !important",
                },
                "& .MuiInputBase-input": {
                  padding: "10px !important",
                },
              }}
            >
              {timezones.map((timezone, index) => (
                <MenuItem key={index} value={timezone.value}>
                  (GMT {timezone.label})
                </MenuItem>
              ))}
            </Select>
          </MDBox>
          {role === RoleLabel[Role.LXO] && (
            <MDButton
              sx={{ textTransform: "none", fontSize: "14px" }}
              variant="outlined"
              color="info"
              onClick={() => {
                triggerCreateEventIfNew()
                setIsOpenModalActionEvent(true)
              }}
            >
              Create Event
            </MDButton>
          )}
        </MDBox>
      </MDBox>
      <MDBox
        sx={({ functions: { pxToRem } }) => ({
          overflowX: "auto",
          marginBottom: pxToRem(16),
        })}
      >
        <MDBox
          minWidth="100%"
          sx={({ breakpoints, functions: { pxToRem } }) => ({
            maxWidth: "100%",
            width: pxToRem(800),
            [breakpoints.down(1600)]: {
              width: pxToRem(600),
            },
          })}
        >
          <FullCalendar
            ref={calendarRef}
            locale={enUS}
            datesSet={({ view }) => {
              if (view?.type === "timeGridWeek") {
                const start = view.currentStart || view.activeStart
                if (start) {
                  lastWeekDateRef.current = moment
                    .utc(start)
                    .format("YYYY-MM-DD")
                }
              }
              if (view?.type === "dayGridMonth") {
                const monthStart = view.currentStart || view.activeStart
                if (monthStart) {
                  currentMonthRef.current = moment
                    .utc(monthStart)
                    .format("YYYY-MM")
                  monthAnchorDateRef.current = moment
                    .utc(monthStart)
                    .add(10, "days")
                    .format("YYYY-MM-DD")
                }
              }
              const rangeStart = view?.currentStart || view?.activeStart
              const rangeEnd = view?.currentEnd || view?.activeEnd
              if (rangeStart && rangeEnd) {
                handleChangeDate(
                  moment(rangeStart).format("YYYY-MM-DD"),
                  moment(rangeEnd).format("YYYY-MM-DD")
                )
              }
            }}
            viewDidMount={({ view }) => {
              setTitle(view.title)
              const start = view.currentStart || view.activeStart
              const end = view.currentEnd || view.activeEnd
              handleChangeDate(
                moment(start).format("YYYY-MM-DD"),
                moment(end).format("YYYY-MM-DD")
              )
            }}
            eventClick={(info) => {
              setData(info.event)
              setOpen(true)
            }}
            height="auto"
            titleFormat={(info) => {
              const startDate = info.start.marker
              const endDate = info.end?.marker

              return `${moment(startDate).format("Do")} ${
                moment(startDate).format("MMMM") !==
                moment(endDate).format("MMMM")
                  ? moment(startDate).format("MMMM")
                  : ""
              } - ${moment(endDate).format("Do")} ${moment(endDate).format(
                "MMMM"
              )}`
            }}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            timeZone="UTC"
            initialView={view}
            headerToolbar={false}
            allDaySlot={false}
            firstDay={1}
            scrollTimeReset={true}
            slotDuration="01:00:00"
            scrollTime="09:00:00"
            dayHeaderContent={({ date }) => {
              let event = []
              for (const i in eventsByDay) {
                if (moment(i).isSame(moment(date), "day")) {
                  event = eventsByDay[i]
                  break
                }
              }
              const isToday = moment(date).isSame(moment(), "day")
              const isWeekends = moment(date).clone().day() % 6 === 0
              return (
                <MDBox sx={calendarDayHeader}>
                  <MDTypography
                    sx={(theme) => ({
                      ...calendarDayTopHeader(theme, {
                        isToday,
                        isWeekends,
                      }),
                      fontSize: "14px !important",
                    })}
                  >
                    {moment(date).format("ddd")}
                  </MDTypography>
                  {view !== "dayGridMonth" && (
                    <MDTypography
                      sx={(theme) => ({
                        ...calendarDayBottomHeader(theme, {
                          isToday,
                          isWeekends,
                        }),
                        fontSize: "14px !important",
                      })}
                    >
                      {moment(date).format("DD")}
                    </MDTypography>
                  )}
                </MDBox>
              )
            }}
            slotLabelContent={({ date }) => (
              <MDTypography sx={calendarSlotLabel}>
                {moment(date).utc().format("H:mm")}
              </MDTypography>
            )}
            events={isLoading ? [] : [...events]}
            eventContent={(arg) => {
              const time =
                arg.event.extendedProps.deadline ||
                moment(arg?.event?.start).add(-7, "h")

              return (
                <MDBox
                  className={`weekly-calendar-event-wrapper`}
                  sx={{
                    width: "100%",
                    backgroundColor: `${arg.backgroundColor}`,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    cursor: "pointer",
                    padding: "2px 6px",
                  }}
                >
                  <MDBox sx={{ display: "none" }}>
                    <p>{JSON.stringify(arg.event)}</p>
                  </MDBox>
                  <MDBox>
                    <MDTypography
                      sx={({ breakpoints }) => ({
                        ...noteTypography(breakpoints),
                        fontSize: "14px !important",
                      })}
                    >
                      {/* {moment(time).format("HH:mm")} */}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    className={`weekly-calendar-event ${arg.event.extendedProps.type}`}
                    sx={({ breakpoints }) => ({
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflow: "hidden",
                      ...descriptionTypography(breakpoints),
                      fontSize: "14px !important",
                      maxWidth: "calc(100% - 40px)",
                    })}
                  >
                    {arg.event.title}
                  </MDBox>
                </MDBox>
              )
            }}
            dayCellContent={(arg) => {
              const { dow, dayNumberText, view, isDisabled } = arg
              const viewType = view.type

              const cellDate =
                arg.dateStr ?? moment(arg.date).format("YYYY-MM-DD")

              const effectiveLeaveData = leaveDataProp ?? leaveData
              const matched = effectiveLeaveData?.data?.calendarDays?.findIndex(
                (item) => item.date === cellDate
              )
              const isActiveDayOff =
                effectiveLeaveData?.data?.calendarDays[matched]?.color ===
                "GREEN"

              return (
                <>
                  {viewType !== "dayGridMonth" || isDisabled ? (
                    <MDBox className="view-normal">{dayNumberText}</MDBox>
                  ) : (
                    <MDBox
                      className={`view-${viewType} ${
                        isActiveDayOff ? "activeDayOff" : ""
                      }`}
                      sx={dayCellStyle(isActiveDayOff, dow)}
                      onClick={(e) => {
                        e.stopPropagation()

                        const api = calendarRef.current?.getApi()
                        const dayEvents =
                          api
                            ?.getEvents()
                            ?.filter((ev) =>
                              moment(ev.start).isSame(arg.date, "day")
                            ) ?? []
                        const array = dayEvents.map((item) => {
                          return {
                            event: item.extendedProps,
                          }
                        })
                        setDataRelatedInformation(array)
                        onClickForDayGridMonth(isActiveDayOff)
                      }}
                    >
                      {dayNumberText}
                    </MDBox>
                  )}
                </>
              )
            }}
          />
        </MDBox>
      </MDBox>
      {dynamicByType(data?.extendedProps?.type)}

      {isOpenModalLeave && (
        <ModalLeaveApplication {...propsModalLeaveApplication} />
      )}
      {isOpenModalLeaveAlert && <ModalLeaveAlert {...propsModalLeaveAlert} />}
      {isOpenModalLeaveAlertHoliday && (
        <ModalLeaveAlert {...propsModalLeaveAlertHoliday} />
      )}
      {isOpenModalLeaveRelatedInformation && (
        <ModalLeaveRelatedInfomation {...propsModalLeaveRelatedInformation} />
      )}
      {isOpenModalLeaveSubmitStatus && (
        <ModalLeaveSubmitStatus {...propsModalLeaveSubmitStatus} />
      )}
      {isOpenModalActionEvent && (
        <ModalActionEvent {...propsModalActionEvent} />
      )}
    </MDBox>
  )
}

export default WeeklyCalendarLXO
